module.exports = __webpack_public_path__ + "static/media/like-rating-hand-svgrepo-com.aadd8364.svg";